import OrderManagementFileUploadRepositoryImpl from './impl/OrderManagementFileUploadRepositoryImpl'

export default {
  getInstance () {
    return new OrderManagementFileUploadRepositoryImpl()
  }
}
